import { Component, OnInit, OnChanges, ViewChild, SimpleChanges } from '@angular/core';
import { Output, Input, EventEmitter } from '@angular/core';
import { AnalyticsService } from '../../services/api';
import { AppSchoolReport, AppProjectReport } from '../../services/api';
import * as ApexCharts from 'apexcharts';
import { DatePipe } from '@angular/common';

const monthName = new Intl.DateTimeFormat("en-us", { month: "short" });
const weekdayName = new Intl.DateTimeFormat("en-us", { weekday: "short" });

@Component({
	selector: 'app-utilization-report',
	templateUrl: 'app-utilization-report.component.html',
	styleUrls: ['app-utilization-report.component.scss'],
	providers: [DatePipe]
})

export class AppUtilizationReportComponent implements OnInit, OnChanges {
	@Input() deviceId:number | undefined = -1;
	@Input() schoolId:number | undefined = -1;
	@Input() projectId:number | undefined = -1;
	@Input() isout:boolean | undefined = false;
	@Input() viewsize: [number, number] = [1000, 200];
	@Input() outstartDate: Date = new Date();
	@Input() outendDate: Date = new Date();
	@Output() backEvent = new EventEmitter();
	currentDate : string = '';
	startDate: Date = new Date();
	endDate: Date = new Date();

	private valueshash = new Map<string, number>();

	name = 'Angular';
	showXAxis = true;
	showYAxis = true;
	gradient = false;
	showLegend = true;
	legendTitle = 'Event Title';
	legendPosition = 'right';
	showXAxisLabel = true;
	tooltipDisabled = false;
	showText = true;
	xAxisLabel = 'Country';
	showYAxisLabel = true;
	yAxisLabel = 'GDP Per Capita';
	showGridLines = true;
	innerPadding = '10%';
	barPadding = 8;
	groupPadding = 16;
	roundDomains = false;
	maxRadius = 10;
	minRadius = 3;
	showSeriesOnHover = true;
	roundEdges: boolean = true;
	animations: boolean = true;
	xScaleMin: any;
	xScaleMax: any;
	showDataLabel = false;
	noBarWhenZero = true;
	trimXAxisTicks = true;
	trimYAxisTicks = true;
	rotateXAxisTicks = true;
	maxXAxisTickLength = 16;
	maxYAxisTickLength = 16;
	colorScheme: any;
	schemeType: string = 'ordinal';
	selectedColorScheme: string = 'vivid';
	selectedYear: number;
	years: string[] = [];
	year:string="Last Year";

	// heatmap
	heatmapMin: number = 0;
	heatmapMax: number = 0;
	calendarData: any[] = [];
	private prev = -1;
	private days: number[] = [];
	private preitem : Date | undefined;

	private colorSets:any[] = [
		{
		  name: 'vivid',
		  selectable: true,
		  group: 'Ordinal',
		  domain: [
			'#A14572',
			'#DDEEF8',
			'#C4E5F8',
			'#ABDCF8',
			'#93D2F8',
			'#7AC9F8',
			'#61C0F8',
			'#48B7F8',
			'#2FAEF8',
			'#17A5F8',
			'#009CF8',
			'#3385D6',
			'#006CBA',
			'#00549F',
			'#003E84'
		  ]
		}];

	constructor(private service: AnalyticsService, private datePipe: DatePipe) {
		this.selectedYear = new Date().getFullYear();
		this.years.push("Last Year");
		for (let year = this.selectedYear; year >= 2020; year--) {
		  this.years.push(year.toString());
		}
		const today = new Date()
		let day = 86400000
		this.endDate = new Date(today.getTime() - (0 * day));
		if(!this.isout)
			this.startDate = new Date(today.getTime() - (365 * day));
		else{
			this.startDate = this.outstartDate;
			this.endDate = this.outendDate;
		}
			
		console.log(this.currentDate);
		this.setColorScheme('vivid');
		}


	ngOnChanges(changes: SimpleChanges): void {
		if(changes.outstartDate){
			this.outstartDate = new Date(changes.outstartDate.currentValue);
			console.log(this.outstartDate);
			const today = new Date()
			let day = 86400000
			this.endDate = new Date(this.outstartDate.getTime() + (90 * day));
			if(!this.isout)
				this.startDate = new Date(today.getTime() - (365 * day));
			else{
				this.startDate = this.outstartDate;
				this.endDate = this.outendDate;
			}

			if(this.schoolId != -1){
				this.getSchoolReports()
			}else if(this.projectId != -1){
				this.getProjectReports();
			}else {
				this.getDeviceReports();
			}

	}

	}

	setColorScheme(name:string) {
		  this.selectedColorScheme = name;
		  this.colorScheme = this.colorSets.find(s => s.name === name);
		}

	calendarAxisTickFormatting(mondayString: string) {
		const monday = new Date(mondayString);
		const month = monday.getMonth();
		const day = monday.getDate();
		const year = monday.getFullYear();
		const lastSunday = new Date(year, month, day - 1);
		const nextSunday = new Date(year, month, day + 6);
		return lastSunday.getMonth() !== nextSunday.getMonth() ? monthName.format(nextSunday) : '';
	  }

	  calendarTooltipText(c:any): string {
		return `
		  <span class="tooltip-label">${c.label} • ${c.cell.date.toLocaleDateString()}</span>
		  <span class="tooltip-val">Total Events: ${c.data.toLocaleString()}</span>
		`;
	  }

	  getCalendarData(): any[] {
		// today
		const now = this.endDate;
		const todaysDay = now.getDate();
		const thisDay = new Date(now.getFullYear(), now.getMonth(), todaysDay);

		// Monday
		const thisMonday = new Date(thisDay.getFullYear(), thisDay.getMonth(), todaysDay - thisDay.getDay() + 1);
		const thisMondayDay = thisMonday.getDate();
		const thisMondayYear = thisMonday.getFullYear();
		const thisMondayMonth = thisMonday.getMonth();

		// 52 weeks before monday
		const calendarData = [];
		const getDate = (d:number) => new Date(thisMondayYear, thisMondayMonth, d);
		let weeks = -52
		if(this.isout) weeks = -13
		for (let week = weeks; week <= 0; week++) {
		  const mondayDay = thisMondayDay + week * 7;
		  const monday = getDate(mondayDay);

		  // one week
		  const series = [];
		  for (let dayOfWeek = 7; dayOfWeek > 0; dayOfWeek--) {
			const date = getDate(mondayDay - 1 + dayOfWeek);

			// skip future dates
			if (date > now || date < this.startDate) {
			  continue;
			}

			// value
			let value = this.valueshash.get(this.getDateFormat(date));
			if(value ==null) value = 0;
			series.push({
			  date,
			  name: weekdayName.format(date),
			  value
			});
		  }

		  calendarData.push({
			name: monday.toString(),
			series
		  });
		}

		return calendarData;
	  }

	private getDateFormat(date:Date){
		var str = date.toString();
		return str
	}

	private getDateString(day:Date){
		if(day == null) day = new Date();
		return this.datePipe.transform(day, 'yyyy-MM-dd')!;
	}

	randomIntFromInterval(min:number, max:number) { // min and max included
		return Math.floor(Math.random() * (max - min + 1) + min)
	  }


	onSelectDate(){
		this.getDates();
		if(this.schoolId != -1){
			this.getSchoolReports()
		}else if(this.projectId != -1){
			this.getProjectReports();
		}else{
			this.getDeviceReports();
		}
	}

	getDates(){
		const today = new Date();
		let startyear = today.getFullYear();
		if(this.year != "Last Year"){
			startyear =  Number(this.year);
			this.startDate = new Date(startyear,0,1);
			this.endDate = new Date(startyear,11,31);
		}else{
			let day = 86400000
			this.endDate = new Date(today.getTime() - (0 * day));
			this.startDate = new Date(today.getTime() - (365 * day));
		}

	}


	getDataArray(data: number[]){
		let array: any[] = [];
		let count = 1;
		data.forEach(item =>{
			let value = {
				x:count,
				y:item
			};
			array.push(value);
			count++;
		});
		return array;
	}

	ngOnInit(): void {
    this.heatmapMax = 0;
    this.heatmapMin = 0;
		if(this.schoolId != -1){
			this.getSchoolReports()
		}else if(this.projectId != -1){
			this.getProjectReports();
		}else {
			this.getDeviceReports();
		}
	}

	private getSchoolReports(){
		this.service.analyticsGetAppUtilSchoolReportPost(this.schoolId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			this.prepareData(data)
			this.calendarData = this.getCalendarData();
		});
	}

	private getProjectReports(){

		this.service.analyticsGetAppUtilProjectReportPost(this.projectId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			console.log(data);
			this.prepareData(data)
			this.calendarData = this.getCalendarData();
		});
	}

	private getDeviceReports(){

		this.service.analyticsGetAppUtilDeviceReportPost(this.deviceId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			console.log(data);
			this.prepareData(data)
			this.calendarData = this.getCalendarData();
		});
	}

	private prepareData(data:any[]){
    this.heatmapMax = 0;
		data = data.reverse();
    console.log(data);
		data.forEach(item =>
			{
				const current:string = this.getDateFormat(new Date(item.createdDate));
				this.valueshash.set(current, item.count!)
				this.heatmapMax = Math.max(this.heatmapMax, item.count!);
				console.log('max' + this.heatmapMax);
			});


	}

	navigateBack(){
		this.backEvent.next(null);
	}

}
